var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "saas-page linear-admin-workflow" }, [
    _c("div", { staticClass: "saas-hero card-saas linear-page-hero" }, [
      _c("div", { staticClass: "saas-hero__main" }, [
        _c(
          "p",
          { staticClass: "saas-hero__crumb" },
          [
            _c("router-link", { attrs: { to: "/home" } }, [
              _vm._v(_vm._s(_vm.trans("general.home"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "px-1" }, [_vm._v("/")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.trans("backup.backup")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c("span", { staticClass: "linear-eyebrow" }, [
          _vm._v(_vm._s(_vm.trans("backup.backup"))),
        ]),
        _vm._v(" "),
        _c("h1", { staticClass: "saas-hero__title" }, [
          _vm._v(_vm._s(_vm.trans("backup.backup"))),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-saas linear-admin-panel mb-3" },
      [
        _c("div", { staticClass: "linear-section-head" }, [
          _c("div", [
            _c("span", [_vm._v(_vm._s(_vm.trans("backup.backup")))]),
            _vm._v(" "),
            _c("h4", [_vm._v(_vm._s(_vm.trans("backup.generate_backup")))]),
          ]),
        ]),
        _vm._v(" "),
        _c("show-tip", { attrs: { module: "backup", tip: "tip_backup" } }),
        _vm._v(" "),
        _c("div", { staticClass: "linear-backup-command" }, [
          _c(
            "div",
            { staticClass: "linear-switch-row" },
            [
              _c("switches", {
                attrs: { theme: "bootstrap", color: "success" },
                model: {
                  value: _vm.backupForm.delete_previous,
                  callback: function ($$v) {
                    _vm.$set(_vm.backupForm, "delete_previous", $$v)
                  },
                  expression: "backupForm.delete_previous",
                },
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.trans("backup.delete_previous_backup?"))),
              ]),
              _vm._v(" "),
              _c("show-tip", {
                attrs: {
                  module: "backup",
                  tip: "tip_delete_previous_backup",
                  type: "field",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.createBackup.apply(null, arguments)
                },
              },
            },
            [_vm._v(_vm._s(_vm.trans("backup.generate_backup")))]
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _vm.backups && _vm.backups.length
      ? _c("div", { staticClass: "admin-list-table-card linear-table-card" }, [
          _c(
            "div",
            { staticClass: "linear-section-head linear-section-head--table" },
            [
              _c("div", [
                _c("span", [_vm._v(_vm._s(_vm.trans("backup.backup")))]),
                _vm._v(" "),
                _c("h4", [_vm._v(_vm._s(_vm.trans("backup.backup")))]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "table-responsive" }, [
            _c(
              "table",
              { staticClass: "table admin-data-table linear-dense-table mb-0" },
              [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.trans("backup.name")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.trans("backup.size")))]),
                    _vm._v(" "),
                    _c("th", { staticClass: "admin-table-actions-cell" }, [
                      _vm._v(_vm._s(_vm.trans("general.actions"))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.backups, function (backup) {
                    return _c("tr", { key: backup.name }, [
                      _c("td", [
                        _c("span", {
                          staticClass: "linear-table-primary",
                          domProps: { textContent: _vm._s(backup.name) },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", {
                          staticClass: "linear-pill",
                          domProps: { textContent: _vm._s(backup.size) },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "admin-table-actions-cell" },
                        [
                          _c(
                            "table-row-action-dropdown",
                            [
                              _c(
                                "b-dropdown-item",
                                {
                                  attrs: {
                                    href: _vm.getDownloadLink(backup),
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c("admin-icon", {
                                    attrs: { name: "download" },
                                  }),
                                  _vm._v(
                                    " Download\n                                "
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item-button",
                                {
                                  directives: [
                                    {
                                      name: "confirm",
                                      rawName: "v-confirm",
                                      value: { ok: _vm.confirmDelete(backup) },
                                      expression: "{ok: confirmDelete(backup)}",
                                    },
                                  ],
                                  staticClass: "admin-row-actions__danger",
                                },
                                [
                                  _c("admin-icon", {
                                    attrs: { name: "trash" },
                                  }),
                                  _vm._v(
                                    " Delete Backup\n                                "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  }),
                  0
                ),
              ]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.backups.length
      ? _c(
          "div",
          {
            staticClass:
              "admin-list-table-card admin-empty-state linear-empty-state",
            attrs: { role: "status" },
          },
          [
            _c("div", { staticClass: "admin-empty-state__inner" }, [
              _c(
                "div",
                {
                  staticClass: "admin-empty-state__icon-wrap",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("admin-icon", { attrs: { name: "database" } })],
                1
              ),
              _vm._v(" "),
              _c("h4", { staticClass: "admin-empty-state__title" }, [
                _vm._v(_vm._s(_vm.trans("general.no_result_found"))),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "admin-empty-state__text" }, [
                _vm._v(_vm._s(_vm.trans("backup.backup"))),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }